import { createStyles } from '@asuikit/styles';

export default createStyles(() => ({
  placeholder: {},
  input: {
    cursor: 'pointer',
  },
}));
